import { create } from "zustand";
import { persist } from "zustand/middleware";
import { usePlacedModelsStore } from "./placedModelsStore";

// Plexian avatar store — persisted, stores the user's saved avatar config
export const usePlexianStore = create(
  persist(
    (set) => ({
      avatarConfig: null,
      avatarId: null,
      isSynced: false,
      setAvatarConfig: (config) => {
        set({ avatarConfig: config, isSynced: false });
        // Propagate to every placed plexian_avatar in the current room so
        // existing placements always reflect the user's latest avatar (you only
        // get one avatar — older placements should never look stale).
        const placed = usePlacedModelsStore.getState().placedModels;
        const interactionOn = !!config?.interactionEnabled
          && (config?.interactiveText || '').length > 0;
        const hoverText = interactionOn ? 'Talk to Plexian' : '';
        const updated = placed.map((m) =>
          m.type === 'plexian_avatar' ? { ...m, avatarConfig: config, hoverText } : m,
        );
        const changed = updated.some((m, i) => m !== placed[i]);
        if (changed) usePlacedModelsStore.setState({ placedModels: updated });
      },
      setAvatarId: (id) => set({ avatarId: id }),
      markSynced: () => set({ isSynced: true }),
      clearAvatar: () => set({ avatarConfig: null, avatarId: null, isSynced: false }),
    }),
    {
      name: "plexian-store",
    }
  )
);
